/**
 * Dynamically updates `alt` text based on screen size for accessibility & SEO.
 * Uses `data-alt` attributes on <source> elements and updates automatically on load and resize.
 * Ensures correct `alt` text is applied when switching between mobile & desktop images.
 */

function media() {
  return {
    init() {
      // Run update on load to ensure correct `alt` text is applied immediately
      this.updateAltText();

      // Optimize resize performance by debouncing updates
      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          requestAnimationFrame(() => this.updateAltText());
        }, 150);
      });
    },

    updateAltText() {
      // Find all instances of `.responsive-picture`
      document.querySelectorAll(".responsive-picture").forEach((picture) => {
        const imgElement = picture.querySelector("img");
        if (!imgElement) return; // Ensure an <img> element exists

        const sources = picture.querySelectorAll("source");
        let newAlt = imgElement.getAttribute("alt") || ""; // Start with the existing `alt`

        // Check which <source> is currently active based on screen size
        sources.forEach((source) => {
          if (window.matchMedia(source.media).matches) {
            const sourceAlt = source.getAttribute("data-alt");
            if (sourceAlt && sourceAlt.trim() !== "") {
              newAlt = sourceAlt;
            }
          }
        });

        // Only update the `alt` attribute if it has changed (performance optimization)
        if (imgElement.getAttribute("alt") !== newAlt) {
          imgElement.setAttribute("alt", newAlt);
        }
      });
    },
  };
}

export default media;
